// import React from 'react'
// import img from "../assets/404.png";

// const NotFound = () => {
//   return (
//     <div style={{display: 'flex', alignItems: 'center', justifyContent:'center', flexDirection: 'column'}}>
//         <img src={img} style={{objectFit: 'contain', width: 400, height: 400}} alt='page-not-found' />
//         <h1 style={{textAlign:'center', color: '#2D2D2D'}}>Page Not Found</h1>
//         <div style={{marginTop: 25}} className='subscribe-btn' onClick={() => window.location.replace('/')}><p>Back to home</p></div>
// </div>
//   )
// }

// export default NotFound
import React from 'react';
import img from '../assets/notfound.png';
import { useNavigate } from 'react-router-dom';
const NotFound = () => {
  const x = useNavigate();
  return (
    <div className='not-found-container'>
      <div className='not-found-card'>
        <img src={img} alt='Page Not Found' className='not-found-image' />
        <h1 className='not-found-title'>Oops! Page Not Found</h1>
        <p className='not-found-text'>
          Looks like you've wandered off track. Let’s get you back home!
        </p>
        <button className='not-found-button' onClick={() => x('/')}>
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default NotFound;
